<template>
  <v-container>
    <v-card outlined class="mb-8">
      <v-card-title>Manage account</v-card-title>
      <v-card-text>
        <text-input v-model="user.displayName" disabled label="Display Name" class="mb-4" />
        <text-input v-model="user.email" disabled label="Email Address" class="mb-4" />
        <text-input v-model="formData.password" label="New Password" type="password" autofocus />
      </v-card-text>
      <v-card-actions>
        <v-btn outlined depressed color="primary" :disabled="disabled" :loading="loading" @click="updatePassword">
          Update Password
        </v-btn>
        <v-btn color="blue-grey darken-3" dark depressed :loading="loading" @click="toggleGoogleProvider">
          <v-img :src="require('@/assets/logos/google.svg')" :max-height="24" :max-width="24" class="mr-2" contain />
          <span>{{ isSyncedToGoogle ? 'Unlink' : 'Link' }} Google Account</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import firebase from '@/services/firebase'
import TextInput from '@/components/forms/text-input'

export default {
  name: 'SettingsEdit',
  components: { TextInput },
  data() {
    return {
      loading: false,
      user: firebase.auth().currentUser,
      providers: firebase.auth().currentUser.providerData,
      formData: { password: null },
    }
  },
  computed: {
    disabled() {
      if (this.loading) return true
      if (!this.formData.password || !this.formData.password.length) return true
      return false
    },
    googleProvider() {
      return this.providers.find(({ providerId }) => providerId === 'google.com')
    },
    isSyncedToGoogle() {
      return !!this.googleProvider
    },
  },
  methods: {
    async toggleGoogleProvider() {
      this.loading = true
      if (this.isSyncedToGoogle) await this.unlinkGoogleProvider()
      if (!this.isSyncedToGoogle) await this.linkGoogleProvider()
      this.providers = await firebase.auth().currentUser.providerData
      this.loading = false
    },
    async linkGoogleProvider() {
      try {
        const provider = new firebase.auth.GoogleAuthProvider()
        await firebase.auth().currentUser.linkWithPopup(provider)
        this.$notify({ type: 'success', text: `Successfully linked google account` })
      } catch (err) {
        this.$notify({ type: 'error', text: `Unable to link google account` })
      }
    },
    async unlinkGoogleProvider() {
      try {
        await firebase.auth().currentUser.unlink(this.googleProvider.providerId)
        this.$notify({ type: 'success', text: `Successfully unlinked google account` })
      } catch (err) {
        this.$notify({ type: 'error', text: `Unable to unlink google account` })
      }
    },
    async updatePassword() {
      try {
        this.loading = true
        await firebase.auth().currentUser.updatePassword(this.formData.password)
        this.$notify({ type: 'success', text: 'Successfully updated password' })
        this.loading = false
        this.formData.password = null
      } catch (err) {
        this.loading = false
        this.$notify({ type: 'error', text: err.message || 'Unable to update password' })
      }
    },
  },
}
</script>
